import React from 'react';
import BattlesLobbyHeader from '@/components/CaseBattles/Header/BattlesPageHeader';
import GamesList from '@/components/CaseBattles/GamesList';
import BattlesLayout from '@/components/Layouts/BattlesLayout';
import SeoHead from '@/components/SEO/SeoHead';

const Page = () => {
    return (
        <>
            <SeoHead category="Case Battles" path="/casebattles" />
            <div className="flex flex-col gap-3 min-w-0 animate-fluent-fadeup">
                <BattlesLobbyHeader />
                <GamesList />
            </div>
        </>
    );
};

Page.getLayout = (page: React.ReactNode) => <BattlesLayout>{page}</BattlesLayout>;

export default Page;
